import { useState } from 'react';

type State = boolean;

export function useModal(
  value?: boolean
): [
  State,
  {
    hideModal: () => void;
    showModal: () => void;
  }
] {
  const [state, setState] = useState<State>(value ?? false);

  function hideModal() {
    setState(false);
  }
  function showModal() {
    setState(true);
  }

  return [state, { hideModal, showModal }];
}
